import * as React from 'react';

import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {GraphQLSelectAudiences} from '../../../../../core/select/graphql-select-audiences';
import {GraphQLSelectAudiencesProvider} from '../../../../../core/select/graphql-select-audiences-provider';

type Props = {
    onChange: (option: ListOptionWithCount) => void;
    selectedId: string | null | undefined;
};

export function SelectAudience(props: Props): React.ReactElement {
    const [audienceOptions, setAudienceOptions] = React.useState<ListOptionWithCount[]>([]);

    return (
        <GraphQLSelectAudiencesProvider>
            {({options, isLoading, refetch}) => {
                if (options.length > 0 && !audienceOptions.length) {
                    setAudienceOptions(options);
                }

                return (
                    <GraphQLSelectAudiences
                        options={options}
                        isLoading={isLoading}
                        isCreateable={true}
                        selectedId={props.selectedId}
                        onChange={props.onChange}
                        // @ts-expect-error
                        menuPlacement='bottom'
                        refetch={refetch}
                        updateOptions={(newValue: ListOptionWithCount) =>
                            setAudienceOptions(audienceOptions.concat(newValue))
                        }
                    />
                );
            }}
        </GraphQLSelectAudiencesProvider>
    );
}
